export const seoLocales = {
  '1001promocodes.com': {
    lang: 'en-US',
    country: 'US',
    ogLocale: 'en_US',
  },

  'tipdeal.us': {
    lang: 'en-US',
    country: 'US',
    ogLocale: 'en_US',
  },

  'tipdeal.co.nz': {
    lang: 'en-NZ',
    country: 'NZ',
    ogLocale: 'en_NZ',
  },

  'tipdeal.nl': {
    lang: 'nl-NL',
    country: 'NL',
    ogLocale: 'nl_NL',
  },

  'tipdeal.be': {
    lang: 'nl-BE',
    country: 'BE',
    ogLocale: 'nl_BE',
  },

  'codigosdescuentospromocionales.es': {
    lang: 'es-ES',
    country: 'ES',
    ogLocale: 'es_ES',
  },

  '1001cupomdedescontos.com.br': {
    lang: 'pt-BR',
    country: 'BR',
    ogLocale: 'pt_BR',
  },

  // Add more as needed
};